// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"54ccb240","402":"9b4b2961","825":"e8804a34","889":"e8804a34"}[chunkId] + ".chunk.css";
};